import { render, staticRenderFns } from "./TableForAdminFAIBlock.vue?vue&type=template&id=0a990d9e&scoped=true&"
import script from "./TableForAdminFAIBlock.vue?vue&type=script&lang=js&"
export * from "./TableForAdminFAIBlock.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/interpreter_for_admin_fai_block.css?vue&type=style&index=0&id=0a990d9e&prod&scoped=true&lang=css&"
import style1 from "./TableForAdminFAIBlock.vue?vue&type=style&index=1&id=0a990d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a990d9e",
  null
  
)

export default component.exports